import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, BookOpenIcon, FolderIcon } from 'lucide-react';
const scrollToCheckout = () => {
  document.getElementById('compra')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function Hero() {
  return <section className="w-full bg-blue-50 py-12 md:py-16 px-4" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-bold text-center text-gray-900 mb-6 leading-snug max-w-3xl mx-auto" data-id="element-38">
          Sesiones, ejercicios y progresiones listas para{' '}
          <span className="text-blue-600" data-id="element-39">formar jugadores</span> con un{' '}
          <span className="text-orange-500" data-id="element-40">método claro y organizado</span>.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-6 cursor-pointer" onClick={scrollToCheckout} data-id="element-41">
          <img src="https://cdn.magicpatterns.com/uploads/bPpg5qZbZ14TkgBX8PnvAb/ChatGPT_Image_Jun_14__2026__05_53_58_PM-removebg-preview.png" alt="Sistema completo para entrenadores de básquet" className="w-[88%] max-w-2xl mx-auto hover:scale-[1.02] transition-transform duration-300" data-id="element-42" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-base md:text-lg text-center text-gray-700 mb-6 max-w-2xl mx-auto leading-snug" data-id="element-43">
          Todo lo que necesitás para estructurar entrenamientos, corregir
          errores técnicos, enseñar fundamentos y hacer progresar a tus
          jugadores paso a paso.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm md:text-base mb-8" data-id="element-44">
          <div className="flex items-center gap-2 text-gray-700" data-id="element-45">
            <FileTextIcon className="w-5 h-5 text-orange-500" data-id="element-46" />
            <span className="font-medium" data-id="element-47">100% PDF</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-48">
            <ZapIcon className="w-5 h-5 text-orange-500" data-id="element-49" />
            <span className="font-medium" data-id="element-50">Acceso Inmediato</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-51">
            <BookOpenIcon className="w-5 h-5 text-orange-500" data-id="element-52" />
            <span className="font-medium" data-id="element-53">12 Tomos + 6 Bonos</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-54">
            <FolderIcon className="w-5 h-5 text-orange-500" data-id="element-55" />
            <span className="font-medium" data-id="element-56">7 Anexos en Excel</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex justify-center" data-id="element-57">
          <button onClick={scrollToCheckout} className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-58">
            Quiero dominar la cancha
          </button>
        </motion.div>
      </div>
    </section>;
}